import { ExcelDataModel, ChartDetails } from '../../../../common/models/chatbotexpand.model';
import { ExcelExportReport } from '../../../../common/models/excel-export-report.model';
import { ExportDataFormatterHelper } from './export-data-formatter.helper';
import * as _ from 'lodash';

export class ExportHandlerHelper {
  static handleExportClick(comp: any) {
    if (comp.mcode == 2 || comp.mcode == 3) {
      const FilterValues = comp.getDistinctChildValues(comp.dataObject.Filter);
      const FilterData = comp.transformData(FilterValues);
      let excelinputs: ExcelDataModel = {
        significance: comp.DefaultSampleSize,
        isTranspose: comp.isTranspose,
        baseType: comp.isTotalBase,
        confidenceLevel: comp.DefaultConfidenceLevel,
        output: '',
        studyName: comp.selected_study,
        clientName: comp.selected_client,
        filters: FilterData.join(','),
        nestingType: comp.isFilteringActive ? 'Filtering' : 'Profiling',
        isFiltering: comp.isFilteringActive,
        selectionInput: comp.dataObject,
        selectionSummary: JSON.stringify(comp.insightsVal),
        failedComments: '',
        isTotal: comp.isTotal,
        lowBase: comp.LowBase == '' ? 0 : Number(comp.LowBase),
        InsufficientBase: comp.insufficientBase == '' ? 0 : Number(comp.insufficientBase),
        threshold: comp.threshold == '' ? 0 : Number(comp.threshold),
        selectedIndex: comp.selectedIndex,
        selectedWeight: comp.selectedWeight,
        DefaultWeight: comp._configService?.weightLabel || comp.DefaultWeight,
        isBrandAnalysis: comp.mcode == 2,
        SignificanceVsReference: comp.replacePipe(comp.SignificanceVsReference),
        DataFormat: comp.selectedDataFormat,
        isSampleSizeBlock: comp.isSampleSizeBlock,
        isWeightedSampleBlock: comp.isWeightedSampleBlock,
        query: comp.chatPreviewBlocks.length > 0 ? comp.chatPreviewBlocks[comp.chatPreviewBlocks.length - 1].question : comp.inputValue,
  QuestionSummary: comp.currentQuestion,
  AnswerSummary: comp.currentAnswer,
      };

      if (!comp.FooterNote) {
        comp._loaderService.showLoader();
        excelinputs.output = JSON.stringify(comp.CrossTabOutPutData);
        comp.$unSubscribeSubmitData5 = comp.apiService.exportToExcelARK(excelinputs).subscribe(
          (excelBlob: Blob) => {
            let datetimeFormat = ExportHandlerHelper.getCurrentDateTime();
            let fileName = 'KantarXTab_' + excelinputs.clientName + '_' + excelinputs.studyName + '_' + datetimeFormat + '.xlsx';
            ExportHandlerHelper.downloadFile(excelBlob, fileName);
            comp._loaderService.hideLoader();
          },
          (error: any) => {
            comp._loaderService.hideLoader();
          }
        );
      } else {
        var istimePeriodWave = comp.isWaveTimePeriod();
        comp.$unSubscribeSubmitData5 = comp._exportDownloads.exportToExcelLargeSelection(excelinputs, istimePeriodWave).subscribe((result: any) => {
          if (result.HasValidData) {
            let ExportReport: ExcelExportReport = JSON.parse(result.Data);
          }
          comp.arktabaccess = false;
        });
      }
    } else if (comp.mcode == 1) {
      ExportHandlerHelper.excelexportClicked(comp);
    }
  }

  static handlePPTExportClick(comp: any) {
    if (comp.mcode == 2 || comp.mcode == 3) {
      // Check if bar chart has multiple categories with single series (brand analysis scenario)
      // In this case, use GroupBarChart path which handles dynamic data properly
      let useGroupBarChart = false;
      if (comp.isVerticalBarChartClick && comp.BarChart?.Data?.length > 1) {
        const uniqueSeriesNames = [...new Set(comp.BarChart.Data.map((d: any) => d['Series Name']))];
        const uniqueCategoryNames = [...new Set(comp.BarChart.Data.map((d: any) => d['Category Name']))];
        // If single series but multiple categories, use GroupBarChart path
        if (uniqueSeriesNames.length === 1 && uniqueCategoryNames.length > 1) {
          useGroupBarChart = true;
        }
      }

      let pptinputs: ChartDetails = {
        selectedSignifcance: comp.DefaultSampleSize == 'Pairwise' ? 'None' : comp.DefaultSampleSize,
        ChartCategory: comp.isLineChartClick
          ? 'LineOrTrendChart'
          : comp.isVerticalBarChartClick || comp.isVerticalGroupBarChartClick
            ? 'Bar'
            : 'StackedBar',
        DisplayName: comp.isLineChartClick
          ? 'Line Chart'
          : (comp.isVerticalBarChartClick && !useGroupBarChart)
            ? 'BarChart'
            : (comp.isVerticalGroupBarChartClick || useGroupBarChart)
              ? 'GroupBarChart'
              : comp.isVerticalStackChartClick && comp.isTranspose
                ? 'StackedBar'
                : 'StackedColumn',
        ChartTitle: comp.isLineChartClick
          ? 'Line Chart'
          : (comp.isVerticalBarChartClick && !useGroupBarChart) && comp.isTranspose
            ? 'horizontal bar chart'
            : (comp.isVerticalBarChartClick && !useGroupBarChart) && !comp.isTranspose
              ? 'vertical bar chart'
              : (comp.isVerticalGroupBarChartClick || useGroupBarChart) && comp.isTranspose
                ? 'Horizontal Cluster Bar Chart'
                : (comp.isVerticalGroupBarChartClick || useGroupBarChart) && !comp.isTranspose
                  ? 'Vertical Cluster Bar Chart'
                  : comp.isVerticalStackChartClick && comp.isTranspose
                    ? 'Horizontal Stacked Chart'
                    : 'Vertical Stacked Chart',
        ChartOutput: comp.isLineChartClick
          ? JSON.stringify(comp.LineChart)
          : comp.isVerticalStackChartClick
            ? JSON.stringify(comp.StackChart)
            : JSON.stringify(comp.BarChart),
        isSolidPattern: false,
        chartId: comp.isLineChartClick
          ? 1
          : comp.isVerticalStackChartClick
            ? 2
            : (comp.isVerticalBarChartClick || comp.isVerticalGroupBarChartClick) && comp.isTranspose
              ? 3
              : (comp.isVerticalBarChartClick || comp.isVerticalGroupBarChartClick) && !comp.isTranspose
                ? 1
                : 0,
        Type: comp.isTranspose ? 'Column' : 'Bar',
        insufficientBase: comp.insufficientBase,
        lowBaseValue: comp.LowBase,
        SelectionSummary: comp.selectionSummary?.replace(/<[^>]*>/g, '') || '',
        query: comp.chatPreviewBlocks.length > 0 ? comp.chatPreviewBlocks[comp.chatPreviewBlocks.length - 1].question : comp.inputValue,
        insightsVal: JSON.stringify(comp.insightsVal),
        QuestionSummary: comp.currentQuestion,
        AnswerSummary: comp.currentAnswer
      };
      comp._loaderService.showLoader();
      comp.$unSubscribeSubmitData7 = comp.apiService.exportToPPT(pptinputs).subscribe(
        (pptBlob: Blob) => {
          comp._loaderService.hideLoader();
          let datetimeFormat = ExportHandlerHelper.getCurrentDateTime();
          let fileName = 'KantarXTab_' + comp.selected_client + '_' + comp.selected_study + '_' + datetimeFormat + '.pptx';
          ExportHandlerHelper.downloadPPTFile(pptBlob, fileName);
        },
        (error: any) => {
          comp._loaderService.hideLoader();
        }
      );
    } else {
      ExportHandlerHelper.editablePPTClicked(comp);
    }
  }
  static fixPayload(data: any) {
    const fix = (arr: any) => (typeof arr === 'string' ? JSON.parse(arr) : arr)?.map((w: any) => {
      const base = (w.response_payload?.inputWidgetDetails ?? w.response_payload_trendline?.inputWidgetDetails ?? [])
        .find((b: any) => b.widget_name === w.widget_name)?.customizationProperties;
      const p = typeof w.customizationProperties === 'string' ? JSON.parse(w.customizationProperties || '{}') : (w.customizationProperties || {});
      if (base && !p.darkTheme) w.customizationProperties = JSON.stringify({ ...JSON.parse(base), ...p });
      return w;
    });
    if (data?.outputArray) data.outputArray = JSON.stringify(fix(data.outputArray));
    if (data?.outputTrendArray) data.outputTrendArray = JSON.stringify(fix(data.outputTrendArray));
    return data;
  }

  static excelexportClicked(comp: any) {
    let allpageOutputDataWithoutTrend = _.cloneDeep(comp._configService.allPageOutputDataWithoutTrend)[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    const filteredDataoutputArray = allpageOutputDataWithoutTrend.filter(
      (item: any) => item.widget_name === comp.filteredWidgetData.widget_name
    );
    const filteredDataoutputTrendArray = comp._configService.allPageOutputData[0].filter(
      (item: any) => item.widget_name === comp.filteredWidgetData.widget_name
    );
    comp._configService.setDropdownValue('outputArray', JSON.stringify(filteredDataoutputArray));
    comp._configService.setDropdownValue('outputTrendArray', JSON.stringify(filteredDataoutputTrendArray));
    ExportHandlerHelper.handleExcelExportClick(comp);
  }

  static handleExcelExportClick(comp: any) {
    let data = comp.Snapshotdataforexport;

    // Fix truncated properties for history snapshots
    data = ExportHandlerHelper.fixPayload(data);

    if (data.compareAcross == 'Multiple Brands' || data.compareAcross == 'Multiple Markets') {
      data = ExportDataFormatterHelper.preapreexceldata(data);
    } else {
      data = ExportDataFormatterHelper.preapreexceldata1(data);
    }

    if (comp.significanceSelectedValue != 'None') {
      data.confidenceLevel = comp.displayConfidenceLevel;
    } else {
      data.confidenceLevel = 'None';
    }
    data.userRole = "superadmin";
    data.custumview = true;
    data.isAggregatedData = comp._configService.isAggregatedData;
    data.isSemiAggregatedData = comp._configService.isSemiAggregatedData;
    data.isRespondentLevel = comp._configService.isRespondentLevel;
    data.compareacrossmultiplesection = data.selectionSummary
      .split('||')[0]
      .trim()
      .split(':')
      .slice(1)
      .map((part: any) => part.trim())
      .join(' | ');
    comp._loaderService.showLoader();
    const payload = { ...data };
    payload.insightSelectionSummary = JSON.stringify(comp.insightsVal);
    payload.QuestionSummary = comp.currentQuestion;
    payload.AnswerSummary = comp.currentAnswer;

    if (typeof payload.outputArray !== 'string') {
      try {
        payload.outputArray = JSON.stringify(payload.outputArray ?? {});
      } catch (e) {
        payload.outputArray = '[]';
      }
    }

    if (typeof payload.outputTrendArray !== 'string') {
      try {
        payload.outputTrendArray = JSON.stringify(payload.outputTrendArray ?? []);
      } catch (e) {
        payload.outputTrendArray = '[]';
      }
    }

    comp.subscriptions.add(
      comp.apiService.exportToExcelARKSnapshot(payload).subscribe(
        (excelBlob: Blob) => {
          let datetimeFormat = ExportHandlerHelper.getCurrentDateTime();
          let fileName = 'Snapshot' + '_' + data.clientName + '_' + data.snapshotName + '_' + data.compareAcross + '_' + datetimeFormat + '.xlsx';
          ExportHandlerHelper.downloadFile(excelBlob, fileName);
          comp._loaderService.hideLoader();
          comp.usageDataLog('Excel Export');
        },
        (error: any) => {
          comp._loaderService.hideLoader();
        }
      )
    );
  }

  static editablePPTClicked(comp: any, isTredendDataRequired: boolean = false) {
    comp._loaderService.showLoader();
    let allpageOutputDataWithoutTrend = _.cloneDeep(comp._configService.allPageOutputDataWithoutTrend)[0].sort(
      (a: any, b: any) => a.previewChartPostion - b.previewChartPostion
    );
    const filteredDataoutputArray = allpageOutputDataWithoutTrend.filter(
      (item: any) => item.widget_name === comp.filteredWidgetData.widget_name
    );
    const filteredDataoutputTrendArray = comp._configService.allPageOutputData[0].filter(
      (item: any) => item.widget_name === comp.filteredWidgetData.widget_name
    );
    comp._configService.setDropdownValue('outputArray', JSON.stringify(filteredDataoutputArray));
    comp._configService.setDropdownValue('outputTrendArray', JSON.stringify(filteredDataoutputTrendArray));
    comp._configService.setDropdownValue('product', 'custom');
    comp._configService.getDropdownValues().staticText = comp._configService.staticText;
    let data = comp.Snapshotdataforexport;

    // Fix truncated properties for history snapshots
    data = ExportHandlerHelper.fixPayload(data);

    data.isAggregatedData = comp._configService.isAggregatedData;
    data.isSemiAggregatedData = comp._configService.isSemiAggregatedData;
    data.isRespondentLevel = comp._configService.isRespondentLevel;

    let newCustomizationData: any;
    if (comp._configService.newCustomizationData != null) {
      newCustomizationData = comp._configService.newCustomizationData;
    }

    if (data.compareAcross == 'Multiple Brands' || data.compareAcross == 'Multiple Markets') {
      data = ExportDataFormatterHelper.preparePPTDataMultipleBrands(data, newCustomizationData);
    } else {
      data = ExportDataFormatterHelper.preparePPTDataSingleBrand(data, newCustomizationData);
    }

    if (comp.significanceSelectedValue != 'None') {
      data.confidenceLevel = comp.displayConfidenceLevel;
    } else {
      data.confidenceLevel = 'None';
    }
    data.colorpalate = JSON.stringify(comp.commonchartmodules?.color1 || []);
    data.globalColorMap = JSON.stringify(comp._configService?.getGlobalColorMap?.() || {});
    data.significance = comp._configService.getDropdownValues().significance;
    data.insightselectionSummary = JSON.stringify(comp.insightsVal);
    data.userInput = comp.chatPreviewBlocks.map((c: any) => c.question).join(', ');
    data.QuestionSummary = comp.currentQuestion;
    data.AnswerSummary = comp.currentAnswer;

    comp.subscriptions.add(
      comp.apiService.callPptExportSnapshot('', data, isTredendDataRequired).subscribe(
        (pptBlob: Blob) => {
          let fileName = comp._configService.getDropdownValues().clientName + '_' + comp._configService.getDropdownValues().snapshotName + '_' + ExportHandlerHelper.getCurrentDateTime() + '.pptx';
          ExportHandlerHelper.downloadPPTFile(pptBlob, fileName);
          comp.usageDataLog('Editable PPT Export');
          let paginationElement = document.getElementById('pagination-div');
          if (paginationElement) {
            paginationElement.style.visibility = 'visible';
          }
          comp._loaderService.hideLoader();
        },
        (error: any) => {
          console.error('Error exporting editable PPT:', error);
          comp.showToast('Error exporting PowerPoint. Please try again.', 'error');

          let paginationElement = document.getElementById('pagination-div');
          if (paginationElement) {
            paginationElement.style.visibility = 'visible';
          }
          comp._loaderService.hideLoader();
        }
      )
    );
  }

  static downloadFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  static downloadPPTFile(data: Blob, filename: string) {
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  static getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const formattedDateTime = `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
    return formattedDateTime;
  }
}
